<template>
  <div class="stock-linked-delivery-notes stock-linked-section">
    <v-subheader class="stock-linked-section__title px-0 font-weight-bold">
      {{ title }}
    </v-subheader>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :items-per-page="-1"
      class="stock-linked-delivery-notes__table stock-linked-table"
    >
      <template v-slot:item.code="{ item }">
        <router-link :to="{ name: 'stock-delivery-notes-view', params: { id: item.id } }">
          {{ item.code }}
        </router-link>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip small :color="statusColor(item.status)" dark>
          {{ statusLabel(item.status) }}
        </v-chip>
      </template>
      <template v-slot:item.direction="{ item }">
        {{ directionLabel(item.direction) }}
      </template>
      <template v-slot:item.date="{ item }">
        {{ item.direction === "inbound" ? item.eta_date || "-" : item.etd_date || "-" }}
      </template>
    </v-data-table>
    <v-alert v-if="!items.length" type="info" dense text class="mt-2">
      {{ emptyMessage }}
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "StockLinkedDeliveryNotesTable",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    emptyMessage: {
      type: String,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t("STOCK.DELIVERY_NOTES.DOCUMENT_CODE"), value: "code", sortable: false },
        { text: this.$t("GENERAL.LABELS.STATUS"), value: "status", sortable: false },
        { text: this.$t("STOCK.DELIVERY_NOTES.DIRECTION"), value: "direction", sortable: false },
        { text: this.$t("STOCK.DELIVERY_NOTES.ETD"), value: "date", sortable: false },
      ];
    },
  },
  methods: {
    statusColor(status) {
      const map = {
        draft: "grey",
        confirmed: "primary",
        executed: "success",
        invoiced: "teal",
        cancelled: "error",
      };
      return map[status] || "grey";
    },
    statusLabel(status) {
      const key = `STOCK.DELIVERY_NOTES.STATUS_${(status || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : status;
    },
    directionLabel(direction) {
      const key = direction === "inbound" ? "STOCK.DELIVERY_NOTES.INBOUND" : "STOCK.DELIVERY_NOTES.OUTBOUND";
      return this.$t(key);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/views/partials/stock/stockLinkedTable.scss";

.stock-linked-delivery-notes__table a {
  text-decoration: none;
  font-weight: 500;
}
.stock-linked-delivery-notes__table a:hover {
  text-decoration: underline;
}
</style>
